import React from 'react';
import Modal from '../../../../shared/modal';
import Button from '../../../../shared/button';


interface IClientDetailsModal {
    openModal: boolean;
    data: any;
    handleCloseModal: () => void;
}

const ClientDetailsModal = ({
    openModal,
    data,
    handleCloseModal,
}: IClientDetailsModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    }

    return (
        <Modal
            open={openModal}
            showInRight
            contentContainerStyle='!min-w-[100vw] md:!min-w-[650px]'
            onClose={onCloseModal}>
            <div className={'p-2 min-w-[95vw] md:min-w-[600px]'}>
                <p className='mb-4 font-semibold text-sm'>Client Details</p>
                <div className='bg-[#e4ede657] rounded-[6px] p-3 my-9'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                        <div className='mb-4'>
                            <p className='font-bold'>Contact ID</p>
                            <p>{data?.ContactID}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Name</p>
                            <p>{data?.Name}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Email</p>
                            <p>{data?.EmailAddress}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Status</p>
                            <p>{data?.ContactStatus}</p>
                        </div>
                    </div>
                    {data?.Addresses && data?.Addresses?.length > 0 &&
                        <div className='my-8'>
                            <p className='mb-2 font-bold'>Addresses</p>
                            {data?.Addresses?.map((item: any, index: number) => {
                                return (
                                    <div className='mb-4'>
                                        <p className='mb-2 font-bold'>Address {index + 1}</p>
                                        <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                                            <div className='mb-4'>
                                                <p className='font-bold'>Address Type</p>
                                                <p>{item?.AddressType}</p>
                                            </div>
                                            <div className='mb-4'>
                                                <p className='font-bold'>City</p>
                                                <p>{item?.City}</p>
                                            </div>
                                            <div className='mb-4'>
                                                <p className='font-bold'>Region</p>
                                                <p>{item?.Region}</p>
                                            </div>
                                            <div className='mb-4'>
                                                <p className='font-bold'>Postal Code</p>
                                                <p>{item?.PostalCode}</p>
                                            </div>
                                            <div className='mb-4'>
                                                <p className='font-bold'>Country</p>
                                                <p>{item?.Country}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    }
                    {data?.Phones && data?.Phones?.length > 0 &&
                        <div className='my-8'>
                            <p className='mb-2 font-bold'>Phones</p>
                            {data?.Phones?.map((item: any, index: number) => {
                                return (
                                    <div className='mb-4'>
                                        <p className='mb-2 font-bold'>Phone {index + 1}</p>
                                        <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                                            <div className='mb-4'>
                                                <p className='font-bold'>Phone Type</p>
                                                <p>{item?.PhoneType}</p>
                                            </div>
                                            <div className='mb-4'>
                                                <p className='font-bold'>Phone Number</p>
                                                <p>{item?.PhoneNumber}</p>
                                            </div>
                                            <div className='mb-4'>
                                                <p className='font-bold'>Phone Area Code</p>
                                                <p>{item?.PhoneAreaCode}</p>
                                            </div>
                                            <div className='mb-4'>
                                                <p className='font-bold'>Phone Country Code</p>
                                                <p>{item?.PhoneCountryCode}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    }
                    {data?.PaymentTerms &&
                        <div className='my-8'>
                            <p className='mb-2 font-bold'>Payment Terms</p>
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                                <div className='mb-4'>
                                    <p className='font-bold'>Bills Type</p>
                                    <p>{data?.PaymentTerms?.Bills?.Type}</p>
                                </div>
                                <div className='mb-4'>
                                    <p className='font-bold'>Bills Day</p>
                                    <p>{data?.PaymentTerms?.Bills?.Day}</p>
                                </div>
                                <div className='mb-4'>
                                    <p className='font-bold'>Sales Type</p>
                                    <p>{data?.PaymentTerms?.Sales?.Type}</p>
                                </div>
                                <div className='mb-4'>
                                    <p className='font-bold'>Sales Day</p>
                                    <p>{data?.PaymentTerms?.Sales?.Day}</p>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className='min-w-[100%] flex flex-row justify-center'>
                    <Button
                        label={'Close'}
                        className={'btn-primary-rounded-less my-9 min-w-full !shadow-none'}
                        type='submit'
                        onClickButton={onCloseModal}
                    />
                </div>
            </div>
        </Modal>
    )
}
export default ClientDetailsModal;